import { motion } from "framer-motion";
import { WhatsappLogo } from "@phosphor-icons/react";
import { CONTACT } from "@/lib/api";

export default function WhatsAppButton() {
  const href = `https://wa.me/${CONTACT.phoneIntl}?text=${encodeURIComponent(
    "Hi Quick Maid Services, I'd like to book a service."
  )}`;
  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noreferrer"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.4, type: "spring", stiffness: 200 }}
      whileHover={{ scale: 1.08 }}
      className="fixed bottom-6 right-6 z-40 grid place-items-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-[#25D366]/40"
      data-testid="whatsapp-float"
      aria-label="Chat on WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
      <WhatsappLogo weight="fill" size={30} className="relative" />
    </motion.a>
  );
}
